import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const selectAllUsers = ({ QualificationsOverview_reducer }) => {
    return QualificationsOverview_reducer.users;
};

export const selectRequiredQualifications = ({ QualificationsOverview_reducer }) => {
    return QualificationsOverview_reducer.qualifications;
};
export const selectQualificationCategories = ({ QualificationsOverview_reducer }) => {
    return QualificationsOverview_reducer.qualificationCategories;
};
export const selectViewCategoryDetailModalInfo = ({ QualificationsOverview_reducer }) => {
    return QualificationsOverview_reducer.viewCategoryModalInfo;
};
export const selectFilteredUsers = createSelector(
    [selectAllUsers],
    (users = false) => {
        if (users) {
            let filteredUsers = Object.keys(users).map(e => {
                let deleted = _.get(users[e], "profile.deleted") || false;
                let userType = _.get(users[e], "profile.type") || "person";
                if (deleted !== true && userType === "person") {
                    return users[e];
                } else {
                    return null;
                }
            });
            filteredUsers = _.compact(filteredUsers);
            return filteredUsers;
        } else return false;
    }
);
export const selectQualificationsInCategory = createSelector(
    [selectRequiredQualifications, selectViewCategoryDetailModalInfo, selectAllUsers],
    (reqQuals = false, modalInfo = false, users = false) => {
        if (reqQuals && modalInfo.category && users) {
            let qualsInCategory = getQualsPerCategory(modalInfo.category, reqQuals);
            let userData = Object.keys(users).map(e => {
                let deleted = _.get(users[e], "profile.deleted") || false;
                let userType = _.get(users[e], "profile.type") || "person";
                if (deleted !== true && userType === "person") {
                    return getUserData(users[e]);
                } else return null;
            });
            userData = _.compact(userData);
            let qualsPerUsers = userData.map(e => {
                return getQualInfoPerUser(qualsInCategory, e);
            });

            return {
                qualsPerUsers: _.orderBy(qualsPerUsers, "completedQuals", "desc"),
                qualsInCategory
            };
        } else return false;
    }
);
export const selectQualificationsByCategory = createSelector(
    [selectRequiredQualifications, selectQualificationCategories, selectAllUsers],
    (reqQuals = false, categories = false, users = false) => {
        if (reqQuals && categories && users) {
            let qualsPerCategory = Object.keys(categories).map(e => {
                return getQualsPerCategory(categories[e], reqQuals);
            });
            let userData = Object.keys(users).map(e => {
                let deleted = _.get(users[e], "profile.deleted") || false;
                let userType = _.get(users[e], "profile.type") || "person";
                if (deleted !== true && userType === "person") {
                    return getUserData(users[e]);
                } else {
                    return null;
                }
            });
            userData = _.compact(userData);
            qualsPerCategory = _.compact(qualsPerCategory);
            let completedQualsInCategoryPerUser = qualsPerCategory.map(e => {
                let completedQuals = getCompletedQualsInCategoryPerUser(e, userData);
                return {
                    category: e.category,
                    totalQuals: e.qualifications.length,
                    completedQuals
                };
            });
            return completedQualsInCategoryPerUser;
        } else {
            return false;
        }
    }
);
const getQualInfoPerUser = (quals, user) => {
    let userQualsInCategory = quals.qualifications.map(e => {
        return user.userQuals[e.qualification_id];
    });
    let completedQuals = 0;
    userQualsInCategory.map(e => {
        let currentDate = moment().endOf("day");

        let expDate = moment(e.qualification_exp_date, "DD/MM/YYYY");

        let verified = e.qualification_verified === "Yes" ? true : false;

        let inDate = expDate.isAfter(currentDate) === true ? true : false;

        if (inDate && verified) completedQuals++;
        return true;
    });
    return { name: user.name, uid: user.uid, userQualsInCategory, completedQuals };
};
const getUserData = user => {
    let userQuals = _.get(user, "profile.qualifications_per_user") || [];
    let fname = _.get(user, "profile.first_name") || "";
    let lname = _.get(user, "profile.last_name") || "";
    let uid = _.get(user, "profile.uid");

    return { name: `${fname} ${lname}`, uid, userQuals };
};
const getCompletedQualsInCategoryPerUser = (qualsInCategory, users) => {
    let quals = _.get(qualsInCategory, "qualifications") || [];

    return quals.map(e => {
        let completedCount = getCompletedCount(e, users);
        return {
            completedCount,
            title: e.qualification_title,
            qualID: e.qualification_id,
            img: e.qualification_valid_img,
            qualification: e
        };
    });
};

const getCompletedCount = (qual, users) => {
    let qualID = _.get(qual, "qualification_id");
    let currentDate = moment().startOf("day");
    let completedCount = 0;
    users.map(e => {
        let userQual = _.get(e, `userQuals.${qualID}`);
        let expDate = _.get(userQual, "qualification_exp_date");
        let verified = _.get(userQual, "qualification_verified");

        let inDate =
            expDate === ""
                ? false
                : moment(expDate, "DD/MM/YYYY").isAfter(currentDate)
                ? true
                : false;
        if (inDate && verified === "Yes") {
            completedCount++;
        }
        return true;
    });
    return completedCount;
};
const getQualsPerCategory = (category, qualifications) => {
    let quals = Object.keys(qualifications).map(e => {
        if (qualifications[e].qualification_category === category) {
            return qualifications[e];
        } else return null;
    });
    return _.compact(quals).length === 0 ? null : { category, qualifications: _.compact(quals) };
};
